import { BaseService } from './BaseService.js';

/**
 * Customer Service
 * Handles all customer-related operations using Laravel API
 */
export class CustomerService extends BaseService {
  constructor() {
    super('customers'); // Laravel endpoint: /api/customers
  }

  /**
   * Search customers by name or email
   */
  async searchCustomers(query) {
    return this.search(query);
  }

  /**
   * Get customer by email
   */
  async getByEmail(email) {
    const response = await this.customCall(`email/${email}`);
    return response;
  }

  /**
   * Create or update customer (upsert)
   */
  async createOrUpdate(customerData) {
    return this.customCall('upsert', 'POST', customerData);
  }

  /**
   * Get customers with specific status
   */
  async getByStatus(status) {
    return this.list(1, 50, { status });
  }

  /**
   * Get customer bookings
   */
  async getCustomerBookings(customerId) {
    return this.customCall(`${customerId}/bookings`);
  }

  /**
   * Get customer invoices
   */
  async getCustomerInvoices(customerId) {
    return this.customCall(`${customerId}/invoices`);
  }

  /**
   * Validate customer data
   */
  validateCustomerData(data) {
    const errors = [];
    
    if (!data.email || !/\S+@\S+\.\S+/.test(data.email)) {
      errors.push('Gültige E-Mail-Adresse erforderlich');
    }
    
    if (!data.first_name || data.first_name.trim().length < 2) {
      errors.push('Vorname muss mindestens 2 Zeichen lang sein');
    }
    
    if (!data.last_name || data.last_name.trim().length < 2) {
      errors.push('Nachname muss mindestens 2 Zeichen lang sein');
    }
    
    return {
      isValid: errors.length === 0,
      errors
    };
  }
}

// Export singleton instance for backward compatibility
const customerService = new CustomerService();
export default customerService; 